export enum PurchasePlatform {
    google = "google",
    apple = "apple",
    web = "web",
}
